"use strict";
/****************************************************************
 * WARNING THIS FILE IS AUTOGENERATED AND SHOULD NOT BE MODIFIED *
 ****************************************************************/
Object.defineProperty(exports, "__esModule", { value: true });
var Realm;
(function (Realm) {
  Realm["R1"] = "R1";
  Realm["OC1"] = "OC1";
  Realm["OC10"] = "OC10";
  Realm["OC11"] = "OC11";
  Realm["OC12"] = "OC12";
  Realm["OC13"] = "OC13";
  Realm["OC14"] = "OC14";
  Realm["OC15"] = "OC15";
  Realm["OC16"] = "OC16";
  Realm["OC17"] = "OC17";
  Realm["OC18"] = "OC18";
  Realm["OC2"] = "OC2";
  Realm["OC3"] = "OC3";
  Realm["OC4"] = "OC4";
  Realm["OC5"] = "OC5";
  Realm["OC6"] = "OC6";
  Realm["OC7"] = "OC7";
  Realm["OC8"] = "OC8";
  Realm["OC9"] = "OC9";
})((Realm = exports.Realm || (exports.Realm = {})));
var Region;
(function (Region) {
  Region["ALW"] = "us-walla-walla-1";
  Region["R1A"] = "R1A";
  Region["R1B"] = "R1B";
  Region["R1G"] = "R1G";
  Region["RNT"] = "us-renton-1";
  Region["SCF"] = "us-scottsdale-1";
  Region["SEA"] = "us-seattle-1";
  Region["AMS"] = "eu-amsterdam-1";
  Region["ARN"] = "eu-stockholm-1";
  Region["AUH"] = "me-abudhabi-1";
  Region["BOM"] = "ap-mumbai-1";
  Region["CDG"] = "eu-paris-1";
  Region["CWL"] = "uk-cardiff-1";
  Region["DXB"] = "me-dubai-1";
  Region["FRA"] = "eu-frankfurt-1";
  Region["GRU"] = "sa-saopaulo-1";
  Region["HYD"] = "ap-hyderabad-1";
  Region["IAD"] = "us-ashburn-1";
  Region["ICN"] = "ap-seoul-1";
  Region["JED"] = "me-jeddah-1";
  Region["JNB"] = "af-johannesburg-1";
  Region["KIX"] = "ap-osaka-1";
  Region["LHR"] = "uk-london-1";
  Region["LIN"] = "eu-milan-1";
  Region["MAD"] = "eu-madrid-1";
  Region["MC"] = "missioncontrol";
  Region["MEL"] = "ap-melbourne-1";
  Region["MRS"] = "eu-marseille-1";
  Region["MTZ"] = "il-jerusalem-1";
  Region["NRT"] = "ap-tokyo-1";
  Region["NUM"] = "me-neom-1";
  Region["ORD"] = "us-chicago-1";
  Region["PHX"] = "us-phoenix-1";
  Region["QRO"] = "mx-queretaro-1";
  Region["SCL"] = "sa-santiago-1";
  Region["SIN"] = "ap-singapore-1";
  Region["SJC"] = "us-sanjose-1";
  Region["SYD"] = "ap-sydney-1";
  Region["VCP"] = "sa-vinhedo-1";
  Region["YNY"] = "ap-chuncheon-1";
  Region["YUL"] = "ca-montreal-1";
  Region["YYZ"] = "ca-toronto-1";
  Region["ZRH"] = "eu-zurich-1";
  Region["WGA"] = "ap-dcc-canberra-1";
  Region["DAL"] = "us-gov-fortworth-3";
  Region["GYR"] = "us-gov-phoenix-3";
  Region["HEF"] = "us-gov-sterling-3";
  Region["PIT"] = "us-gov-boyers-1";
  Region["GEU"] = "us-gov-phoenix-2";
  Region["OKV"] = "us-gov-ashburn-2";
  Region["VEL"] = "us-gov-saltlake-1";
  Region["TUU"] = "me-dcc-neom-1";
  Region["BGY"] = "eu-dcc-milan-1";
  Region["DTM"] = "eu-dcc-rating-2";
  Region["DUS"] = "eu-dcc-rating-1";
  Region["MXP"] = "eu-dcc-milan-2";
  Region["ORK"] = "eu-dcc-dublin-1";
  Region["SNN"] = "eu-dcc-dublin-2";
  Region["DAC"] = "ap-dcc-gazipur-1";
  Region["SGU"] = "us-westjordan-1";
  Region["GCN"] = "us-dcc-phoenix-2";
  Region["IFP"] = "us-dcc-phoenix-1";
  Region["PRC"] = "us-dcc-phoenix-3";
  Region["LFI"] = "us-langley-1";
  Region["LUF"] = "us-luke-1";
  Region["PIA"] = "us-gov-chicago-1";
  Region["RIC"] = "us-gov-ashburn-1";
  Region["TUS"] = "us-gov-phoenix-1";
  Region["BRS"] = "uk-gov-cardiff-1";
  Region["LTN"] = "uk-gov-london-1";
  Region["TIW"] = "us-tacoma-1";
  Region["DCA"] = "us-gov-sterling-2";
  Region["FTW"] = "us-gov-fortworth-1";
  Region["BWI"] = "us-gov-sterling-1";
  Region["NJA"] = "ap-chiyoda-1";
  Region["UKB"] = "ap-ibaraki-1";
  Region["MCT"] = "me-dcc-muscat-1";
})((Region = exports.Region || (exports.Region = {})));
